module.exports = __webpack_public_path__ + "android-icon-192x192.png?04ae03f1ded0a8f1622ca0f458baa7c6";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/android-icon-192x192.png
// module id = 122
// module chunks = 0